import React from "react";


export const useValidateAcceptDateUsingDecType=(decType,isImportShipment,isDMS,acceptanceEpoch)=>{
    const response=React.useRef({})
    return React.useMemo(()=>{
        if(isDMS || isImportShipment) return response.current
        else 
    return ["X","Y"].includes(decType) && (!acceptanceEpoch || acceptanceEpoch==-999) ? {validationMsg:"Acceptance date is mandatory If value of declaration Type is X or Y"} : response.current
        
    },[isImportShipment,isDMS,decType,acceptanceEpoch])
}